import { render, staticRenderFns } from "./ServiceTab.vue?vue&type=template&id=3f944e6b&scoped=true&"
import script from "./ServiceTab.vue?vue&type=script&lang=js&"
export * from "./ServiceTab.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTab.vue?vue&type=style&index=0&id=3f944e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f944e6b",
  null
  
)

export default component.exports